import { useMarketplaceConfig } from '../../queries/marketplace';
import { resolveCryptoCashierConfig } from './resolveCryptoCashierConfig';

export const useCryptoProvider = () => {
  const { data } = useMarketplaceConfig();
  return resolveCryptoCashierConfig(data?.marketplaceConfig);
};
